define(function (require) {
	"use strict";

	var LE = require("app");
	var template = require("user-management-templates/lobs/lobEdit.tmpl");
	var Button = require("ui/button/Button");
	var InputField = require("ui/input-field/InputField");
	var InlineTextarea = require("ui/inline-textarea/InlineTextarea");

	var LobEditView = {};

	function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

		LobEditView = Marionette.ItemView.extend({
			className: "lob-edit",
			template: template,
			ui:{
				lobName: ".lob-name-input",
				lobDescription: ".lob-description",
				cancelButton: ".cancel-button",
				saveButton: ".save-button",
				idContainer: ".lob-id-container"
			},
			uiComponents: {
				lobName: {
					type: InputField,
					options: {
						el: "view.ui.lobName",
						permutation: InputField.Permutation.B,
						maxLength: "view.modelValidators.maxNameLength",
						value: "view.model.getName"
					},
					events: {
						change: "_onNameChange"
					}
				},
				lobDescription: {
					type: InlineTextarea,
					options: {
						permutation: InlineTextarea.PERMUTATION.A,
						container: "view.ui.lobDescription",
						value: "view.model.getDescription",
					},
					events: {
						change: "_onDescriptionChange"
					}
				},
				cancelButton: {
					type: Button,
					options: {
						el: "view.ui.cancelButton",
						permutation: Button.PERMUTATION.LINK
					},
					events: {
						"click": "_onCancel"
					}
				},
				saveButton: {
					type: Button,
					options: {
						el: "view.ui.saveButton",
						permutation: Button.PERMUTATION.BTN_PRIMARY
					},
					events: {
						"click": "_onSave"
					}
				}
			},
			modelEvents: {
				"change": "_onModelChange"
			},

			//<editor-fold desc="Marionette-Functions">
			/*-----------------------------------------------------------------------------------------------*/
			initialize: function(options) {
				this._initialize(options);
			},
			onRender: function() {
				this._onRender();
			},
			//</editor-fold>

			//<editor-fold desc="publicFunctions">
			/*-----------------------------------------------------------------------------------------------*/
			//</editor-fold>


			//<editor-fold desc="privateFunctions">
			/*-----------------------------------------------------------------------------------------------*/
			_initialize: function(options) {
				this.model = options.model;
				this.modelValidators = this.model.MODEL_VALIDATORS;
				this.channel = LEUserManagement.media.channel(LEUserManagement.channels.LOB_EDIT);
			},

			_onRender: function() {
				this._bindEvents();
				this._updateSaveButtonState();
				this._setFocus();
				this.ui.idContainer.toggleClass("hide", this.model.isNew());
			},

			_bindEvents: function() {
				this.listenTo(this.channel, "lob:save:error", this._onSaveError);
			},

			_setFocus: function() {
				this.uiComponents.lobName.setFocus(true);
			},

			_updateSaveButtonState: function() {
				var isModelValid = this.model.validateSaveEnabled();

				if (!isModelValid) {
					this.uiComponents.saveButton.setEnabled(false);
					this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.lobEdit.saveButton.tooltip.mandatoryFields"));
				}
				else {
					if (!this.model.isValueChanged()) {
						this.uiComponents.saveButton.setEnabled(false);
						this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.lobEdit.saveButton.tooltip.noChanges"));
					}
					else {
						this.uiComponents.saveButton.setEnabled(true);
						this.uiComponents.saveButton.setTooltip("");
					}
				}
			},

			_onModelChange: function(options) {
				this._updateSaveButtonState(options);
			},

			_onNameChange: function(componentId, eventName, value) {
				this.channel.trigger("lob:change:name", value);
			},

			_onDescriptionChange: function(componentId, eventName, value) {
				this.channel.trigger("lob:change:description", value);
			},

			_onCancel: function() {
				this.channel.trigger("lob:cancel");
			},

			_onSave: function() {
				this.channel.trigger("lob:save");
			},

			_onSaveSuccess: function() {
				this._hideErrors();
			},

			_onSaveError: function(errors) {
				this._setErrors(errors);
			},

			_setErrors: function(errors) {
				this._hideErrors();

				this.errorsOnPage = errors;

				if (_.has(errors, this.model.KEYS.NAME)) {
					this.uiComponents.lobName.setError(true, errors[this.model.KEYS.NAME]);
				}

				if (_.has(errors, this.model.KEYS.DESCRIPTION)) {
					this.uiComponents.lobDescription.setError(true, errors[this.model.KEYS.DESCRIPTION]);
				}
			},

			_hideErrors: function () {
				this.errorsOnPage = null;
				this.uiComponents.lobName.setError(false);
				this.uiComponents.lobDescription.setError(false);
			}


			//</editor-fold>
		});
	}

	LE.module("LEUserManagement", moduleDefinition);

	return LobEditView;

});
